import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageContent } from '../../../hooks/useContentful';
import { ContentfulMultilineText } from '../../Contentful';
import { HandDrawnButton } from '../../shared/HandDrawnButton/HandDrawnButton';
import './FilmHero.css';

const FilmHero: React.FC = () => {
  const { t } = useTranslation();
  const { data: pageContentData } = usePageContent('film-collection');
  const pageContent = pageContentData?.[0]?.fields as any;
  
  return (
    <div className="film-hero" data-scroll-section="hero">
      <div className="film-hero__content">
        <ContentfulMultilineText 
          content={pageContent?.ctaText} 
          fallback={t('pages/filmCollection:cta.text')}
          as="h1"
        />
        <HandDrawnButton
          text={t('pages/filmCollection:cta.button')}
          variant="brand"
          color="awasi"
          animation="stroke-to-fill"
          size="normal"
          className="film-hero__button"
        />
      </div>
    </div>
  );
};

export default FilmHero;